class StrapSizes {
    constructor() {
        this.sizeOptionsList = document.getElementById("size-options-list");
        this.inputSizeProperty = document.getElementById("selected-size");
        this.addToCartButton = document.querySelector('button[name="add"]');
        this.errorMessage = document.getElementById("size-message-error");
        this.siteOptionsList = document.getElementById("size-options-list");
        this.sizeOptionsHeader = document.getElementById("size-options-header");
        this.sizeOptionsLabel = document.getElementById("size-options-label");
        this.dropdownButton = this.sizeOptionsHeader.querySelector(
            'button[aria-controls="size-options-list"]'
        );
        this.sizeItems = document.querySelectorAll(".size-item");

        this.buyItNowWrapper = null;
        this.buyItNowButton = null;

        // Initialize event listeners
        this.init();
    }

    init() {
        this.findBuyItNowButton();

        this.addToCartButton.classList.add("inactive");

        this.addToCartButton.addEventListener("click", (e) => this.checkSizeValue(e));

        this.sizeOptionsList.addEventListener("click", (e) => this.getSizeValue(e));
        this.sizeOptionsHeader.addEventListener("click", () => this.toggleSizesList());

        this.sizeItems.forEach((item) => {
            item.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.selectSize(item);
                }
            });
        });
    }

    findBuyItNowButton = () => {
        this.buyItNowWrapper = document.querySelector('shopify-buy-it-now-button');
        this.buyItNowButton = document.querySelector('shopify-buy-it-now-button button');

        if (this.buyItNowWrapper && this.buyItNowButton) {
            this.buyItNowButton.classList.add("inactive");

            this.buyItNowWrapper.addEventListener("click", (e) => this.checkSizeValue(e), true);
            this.buyItNowButton.addEventListener("click", (e) => this.checkSizeValue(e), true);
        }
    };

    updateButtonsState = (disabled) => {
        if (disabled) {
            this.addToCartButton.classList.add("inactive");

            if (this.buyItNowButton) {
                this.buyItNowButton.classList.add("inactive");
            }
        } else {
            this.addToCartButton.classList.remove("inactive");

            if (this.buyItNowButton) {
                this.buyItNowButton.classList.remove("inactive");
            }
        }
    };

    checkSizeValue = (e) => {
        if (!this.inputSizeProperty.value) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            this.errorMessage.classList.add("show");

            setTimeout(() => {
                this.errorMessage.classList.remove("show");
            }, 3000);

            return false;
        }
    };

    getSizeValue = (event) => {
        const item = event.target.closest(".size-item");
        if (!item) return;
        this.selectSize(item);
    };

    selectSize = (item) => {
        this.inputSizeProperty.setAttribute("value", item.getAttribute("data-size"));
        this.siteOptionsList.classList.remove("show");
        this.sizeOptionsLabel.innerHTML = item.getAttribute("data-size");

        this.siteOptionsList.hidden = true;
        this.dropdownButton.setAttribute("aria-expanded", "false");

        this.updateButtonsState(false);

        this.sizeItems.forEach((el) => el.classList.remove("selected"));
        item.classList.add("selected");

        if (this.errorMessage.classList.contains("show")) {
            this.errorMessage.classList.remove("show");
        }
    };

    toggleSizesList = () => {
        const isOpen = this.siteOptionsList.classList.contains("show");
        this.siteOptionsList.classList.toggle("show");
        this.siteOptionsList.hidden = isOpen;
        this.dropdownButton.setAttribute("aria-expanded", String(!isOpen));
    };
}

new StrapSizes();
